/* ============================================================================
   dntk-story-teilen.js · DNTK-Radio & TV · Fassung 2026-10-26 (Look des Radio-Players am Handy, Wunsch Sascha;
   2026-10-02: DNTK-PLUS oben in Weiß, Plus-Zeichen in DNTK-Rot)
   Story-Bild beim Teilen: DNTK Radio Pro Global (Titel im Player, TV-Stream, Liste),
   Gallery und Playlist-Galerie.

   Am Handy entsteht ein Story-Bild im Hochformat (1080 x 1920), das aussieht wie das
   Radio am Handy (seit 2026-10-26): Karte mit Leuchtrand in der Akzentfarbe, Kopfzeile mit
   Name (z. B. DNTK RADIO & TV, bei PLUS-Titeln + DNTK-PLUS) und den Plattform-Symbolen des
   Radios, Cover ueber die ganze Breite mit Verlauf in Schwarz, Titel und Artist im Verlauf,
   darunter Fortschritt und Bedienung (nur Bild). Kein Knopf und keine Adresse im Bild.
   Dazu Text und Link, z. B. fuer Instagram-Story oder WhatsApp-Status.

   Das Radio bleibt Zeile fuer Zeile, wie es ist. Das Modul haengt sich an seine globalen
   Funktionen shareCurrentTrack und shareTVStream. Der Link ist derselbe wie bisher
   (?play=<id> bzw. ?livetv=<id>) und laeuft durch mmKennungAnhaengen des Radios
   (angemeldete Verkaeufer teilen mit ihrer Kennung; nie ersetzen, nie mischen).
   Klappt das Story-Bild nicht (kein Teilen mit Dateien, Cover laedt nicht, App ohne
   Teilen-Funktion), laeuft unveraendert die bisherige Funktion des Radios:
   Cover und Link bzw. Link in die Zwischenablage.
   „Liste teilen“ (shareCurrentList): Story-Bild mit den ersten vier Covern der Liste,
   Listenname und Anzahl der Titel. Den Link baut weiter das Radio selbst; das Modul
   liest ihn nur ab (das Teilen-Fenster wird fuer diesen einen Aufruf abgefangen).

   Einbau: eine Zeile am Ende von snippets/dntk-plus-radio.liquid (laedt in beiden
   Radio-Sections):  <script src="{{ 'dntk-story-teilen.js' | asset_url }}" defer></script>
   Gallery und Playlist-Galerie laden das Script selbst und rufen DNTKStory.teile().
   Die Angebots-Section (PLUS- und FREE-Karten) laedt es ebenfalls und zeichnet ihr Bild mit
   DNTKStory.bild() (Kopfzeile + DNTK-PLUS bzw. DNTK-FREE, rechts die Social-Symbole der Karte).
   Mehrfach eingebunden schadet nicht, es laeuft nur einmal.

   Oeffentlich:
     DNTKStory.bild(d)        -> Promise<File|null>
     DNTKStory.teile(d)       -> Promise<boolean>   true = geteilt oder vom Nutzer abgebrochen,
                                                    false = nicht moeglich, bitte wie bisher teilen
     DNTKStory.vorbereiten(d) Bild schon beim Antippen bauen
     DNTKStory.farbe(css)     -> 'r, g, b' (Farbe oder Liste von Kandidaten; zu dunkel oder zu hell = DNTK-Rot)
     DNTKStory.symbole(svgs)  -> [{ raster, pfade }] aus SVG-Elementen (fuer d.symbole)
       d = { cover, titel, artist, info, ruf, marke, kopf, plus, zeit, akzent, text, link }
       kopf = Name in der Kopfzeile (sonst marke, sonst Name des Radios auf der Seite),
       symbole = Symbole rechts in der Kopfzeile (Liste, auch leer); fehlt es: Plattform-Symbole des Radios,
       zeit = { jetzt: '0:14', dauer: '4:57', anteil: 0..1 } (optional), info = zweite Zeile ohne Artist,
       ruf bleibt erlaubt, wird aber nicht mehr gezeichnet
       cover = Adresse oder Liste von Adressen (ab vier: Collage 2 x 2), akzent = CSS-Farbe, 'r, g, b' oder Liste
   Regeln: Übergabe-Protokoll https://claude.ai/code/artifact/e5984669-eb75-4205-a1dd-857024ef1eaf
   ============================================================================ */
(function () {
  'use strict';
  if (window.DNTKStory) { return; }

  var W = 1080, H = 1920;
  var SCHRIFT = 'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
  var WARTEN = 4000;          /* laenger wartet das Teilen nicht auf das Bild */
  var orig = {};
  var merk = null;            /* { schluessel, versprechen }: zuletzt gebautes Bild */
  var laeuft = 0;             /* Zeitpunkt des laufenden Teilens (Schutz vor Doppelklick) */

  /* ------------------------------------------------------------- Zeichnen */
  function ladeBild(src) {
    return new Promise(function (ok, nein) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { ok(img); };
      img.onerror = function () { nein(new Error('Bild')); };
      img.src = src;
    });
  }
  function fuellend(g, img, x, y, w, h) {
    var s = Math.max(w / img.naturalWidth, h / img.naturalHeight);
    var sw = w / s, sh = h / s;
    g.drawImage(img, (img.naturalWidth - sw) / 2, (img.naturalHeight - sh) / 2, sw, sh, x, y, w, h);
  }
  function eingepasst(g, img, x, y, w, h) {
    var s = Math.min(w / img.naturalWidth, h / img.naturalHeight);
    var dw = img.naturalWidth * s, dh = img.naturalHeight * s;
    g.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
  }
  function rund(g, x, y, w, h, r) {
    g.beginPath();
    g.moveTo(x + r, y);
    g.arcTo(x + w, y, x + w, y + h, r);
    g.arcTo(x + w, y + h, x, y + h, r);
    g.arcTo(x, y + h, x, y, r);
    g.arcTo(x, y, x + w, y, r);
    g.closePath();
  }
  function zeilen(g, text, breite, max) {
    var woerter = String(text || '').split(/\s+/).filter(Boolean);
    var liste = [];
    var zeile = '';
    for (var i = 0; i < woerter.length; i++) {
      var probe = zeile ? zeile + ' ' + woerter[i] : woerter[i];
      if (g.measureText(probe).width <= breite || !zeile) { zeile = probe; continue; }
      liste.push(zeile);
      zeile = woerter[i];
      if (liste.length === max) { break; }
    }
    if (liste.length < max && zeile) { liste.push(zeile); }
    else if (liste.length === max && (zeile || i < woerter.length)) {
      var letzte = liste[max - 1];
      while (letzte.length > 1 && g.measureText(letzte + ' …').width > breite) { letzte = letzte.slice(0, -1); }
      liste[max - 1] = letzte.replace(/\s+$/, '') + ' …';
    }
    return liste;
  }
  function gesperrtBreite(g, text, abstand) {
    var b = 0;
    for (var i = 0; i < text.length; i++) { b += g.measureText(text[i]).width + (i < text.length - 1 ? abstand : 0); }
    return b;
  }
  function gesperrt(g, text, x, y, abstand) {
    g.textAlign = 'left';
    for (var i = 0; i < text.length; i++) { g.fillText(text[i], x, y); x += g.measureText(text[i]).width + abstand; }
  }

  /* Cover als Liste brauchbarer Adressen (ohne Platzhalter, ohne Doppelte). */
  function coverListe(c) {
    var roh = Array.isArray(c) ? c : [c];
    var liste = [];
    roh.forEach(function (a) {
      a = String(a || '');
      if (!a || a.indexOf('data:') === 0) { return; }
      if (a.indexOf('//') === 0) { a = 'https:' + a; }
      if (liste.indexOf(a) < 0) { liste.push(a); }
    });
    return liste;
  }
  /* Fuer die Collage reichen 600 px je Cover (Shopify-Bildadressen mit width=). */
  function kleiner(a) {
    return a.replace(/([?&]width=)\d+/, function (alles, vorn) { return vorn + '600'; });
  }
  /* CSS-Farbe oder 'r, g, b' -> [r, g, b] oder null */
  function farbwerte(css) {
    var roh = String(css || '').trim();
    if (!roh) { return null; }
    try {
      if (!/^\d+\s*,\s*\d+\s*,\s*\d+$/.test(roh)) {
        var probe = document.createElement('span');
        probe.style.color = roh;
        if (!probe.style.color) { return null; }
        probe.style.display = 'none';
        document.body.appendChild(probe);
        roh = window.getComputedStyle(probe).color || '';
        probe.parentNode.removeChild(probe);
      }
      var z = roh.match(/\d+(\.\d+)?/g);
      if (!z || z.length < 3) { return null; }
      if (z.length > 3 && Number(z[3]) < 0.5) { return null; }   /* durchsichtig */
      return [Math.round(z[0]), Math.round(z[1]), Math.round(z[2])];
    } catch (e) { return null; }
  }
  /* Akzentfarbe fuer das Bild als 'r, g, b'. Nimmt eine Farbe oder eine Liste von Kandidaten und
     waehlt die erste, auf der weisse Schrift lesbar ist und die sich vom dunklen Grund abhebt
     (nicht fast schwarz, nicht fast weiss); sonst das DNTK-Rot. */
  function farbe(css) {
    var liste = Array.isArray(css) ? css : [css];
    for (var i = 0; i < liste.length; i++) {
      var w = farbwerte(liste[i]);
      if (!w) { continue; }
      var hell = 0.299 * w[0] + 0.587 * w[1] + 0.114 * w[2];
      if (hell >= 30 && hell <= 200) { return w.join(', '); }
    }
    return '205, 0, 57';
  }

  /* Symbole fuer das Story-Bild (aus dem Radio-Player uebernommen, Raster 24 x 24). */
  var SYM = {
    zufall: 'M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z',
    zurueck: 'M6 6h2v12H6zm3.5 6l8.5 6V6z',
    spielen: 'M8 5v14l11-7z',
    vor: 'M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z',
    wiederholen: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z',
    teilen: 'M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92z',
    herz: 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z'
  };
  /* Pfad (SVG-Schreibweise) in ein Quadrat zeichnen; ohne Path2D (sehr alte Browser) bleibt es leer. */
  function symbol(g, pfade, x, y, groesse, farbe, raster) {
    if (typeof window.Path2D !== 'function') { return; }
    var r = raster || [0, 0, 24, 24];
    var s = groesse / Math.max(r[2], r[3]);
    try {
      g.save();
      g.translate(x - r[0] * s + (groesse - r[2] * s) / 2, y - r[1] * s + (groesse - r[3] * s) / 2);
      g.scale(s, s);
      g.fillStyle = farbe;
      (Array.isArray(pfade) ? pfade : [pfade]).forEach(function (p) { g.fill(new window.Path2D(p)); });
      g.restore();
    } catch (e) { try { g.restore(); } catch (x) {} }
  }
  /* Symbole aus SVG-Elementen lesen (nur gefuellte Pfade, hoechstens vier): [{ raster, pfade }] */
  function symboleAus(svgs) {
    var liste = [];
    try {
      for (var i = 0; svgs && i < svgs.length && liste.length < 4; i++) {
        var vb = String(svgs[i].getAttribute('viewBox') || '0 0 24 24').split(/[\s,]+/).map(Number);
        var pfade = [];
        var ps = svgs[i].querySelectorAll('path');
        for (var j = 0; j < ps.length; j++) { if (ps[j].getAttribute('d')) { pfade.push(ps[j].getAttribute('d')); } }
        if (pfade.length && vb.length === 4 && vb[2] > 0 && vb[3] > 0) { liste.push({ raster: vb, pfade: pfade }); }
      }
    } catch (e) {}
    return liste;
  }
  /* Musik-Plattformen aus der Kopfzeile des Radios (Spotify, Apple Music, YouTube, Deezer), falls auf der Seite. */
  function plattformSymbole() {
    try { return symboleAus(document.querySelectorAll('.dntk-pro-wrapper .partner-socials .partner-social-icon svg')); } catch (e) { return []; }
  }
  /* Ueberschrift des Radios (z. B. „DNTK RADIO & TV“), falls auf der Seite. */
  function radioName() {
    try {
      var h = document.querySelector('.dntk-pro-wrapper .dntk-title');
      return h ? String(h.textContent || '').replace(/\s+/g, ' ').trim().toUpperCase() : '';
    } catch (e) { return ''; }
  }

  /* Story-Bild 1080 x 1920 im Look des Radio-Players am Handy: Karte mit Leuchtrand, Kopfzeile mit Name und
     Plattform-Symbolen, Cover ueber die ganze Breite mit Verlauf in Schwarz, Titel und Artist im Verlauf,
     darunter Fortschritt und Bedienung (nur Bild). Oben und unten bleibt Platz fuer die Leisten von Instagram
     und WhatsApp. Kein Knopf und keine Adresse im Bild; der Link geht als Text mit. */
  function storyBild(d) {
    var adressen = coverListe(d && d.cover);
    if (!adressen.length) { return Promise.resolve(null); }
    var collage = adressen.length >= 4;
    if (collage) { adressen = adressen.slice(0, 4).map(kleiner); } else { adressen = adressen.slice(0, 1); }
    var akzent = farbe(d.akzent);
    var schrift = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
    var laden = adressen.map(function (a) { return ladeBild(a).then(null, function () { return null; }); });
    return Promise.all([Promise.all(laden), schrift]).then(function (r) {
      var bilder = r[0].filter(Boolean);
      if (!bilder.length) { return null; }
      if (bilder.length < 4) { collage = false; }
      var img = bilder[0];
      var A = 'rgb(' + akzent + ')';
      var c = document.createElement('canvas');
      c.width = W; c.height = H;
      var g = c.getContext('2d');

      /* Hintergrund: Cover klein zeichnen und gross ziehen = weich, auch ohne Canvas-Filter (Safari) */
      var klein = document.createElement('canvas');
      klein.width = 18; klein.height = 32;
      fuellend(klein.getContext('2d'), img, 0, 0, 18, 32);
      g.fillStyle = '#000'; g.fillRect(0, 0, W, H);
      g.imageSmoothingEnabled = true;
      try { g.imageSmoothingQuality = 'high'; } catch (e) {}
      g.drawImage(klein, 0, 0, W, H);
      g.fillStyle = 'rgba(0, 0, 0, 0.6)'; g.fillRect(0, 0, W, H);

      /* Masse der Karte (wie das Radio am Handy, Cover 309 von 370 px Hoehe) */
      var KX = 60, KW = 960, KR = 44, KOPF = 132, CH = 800, LEISTE = 84, BED = 226;
      var KH = KOPF + CH + LEISTE + BED;
      var KY = Math.round((H - KH) / 2);
      var CY = KY + KOPF, CU = CY + CH;

      /* Karte mit Leuchtrand */
      g.save();
      g.shadowColor = 'rgba(' + akzent + ', 0.85)';
      g.shadowBlur = 110;
      rund(g, KX, KY, KW, KH, KR);
      g.fillStyle = '#000';
      g.fill();
      g.restore();

      g.save();
      rund(g, KX, KY, KW, KH, KR);
      g.clip();

      /* Cover ueber die ganze Breite, oben buendig: quadratisch zugeschnitten, unten abgeschnitten (wie am Handy) */
      g.save();
      g.beginPath(); g.rect(KX, CY, KW, CH); g.clip();
      g.drawImage(klein, KX, CY, KW, CH);
      if (collage) {
        var hw = KW / 2, hh = CH / 2;
        fuellend(g, bilder[0], KX, CY, hw, hh);
        fuellend(g, bilder[1], KX + hw, CY, hw, hh);
        fuellend(g, bilder[2], KX, CY + hh, hw, hh);
        fuellend(g, bilder[3], KX + hw, CY + hh, hw, hh);
      } else {
        fuellend(g, img, KX, CY, KW, KW);
      }
      /* Verlauf in Schwarz ueber die unteren 58 % */
      var vy = CY + CH * 0.42;
      var vl = g.createLinearGradient(0, vy, 0, CU + 1);
      vl.addColorStop(0, 'rgba(0, 0, 0, 0)');
      vl.addColorStop(0.4, 'rgba(0, 0, 0, 0.55)');
      vl.addColorStop(0.72, 'rgba(0, 0, 0, 0.88)');
      vl.addColorStop(1, '#000');
      g.fillStyle = vl;
      g.fillRect(KX, vy, KW, CU + 1 - vy);
      g.restore();

      /* Kopfzeile: Name links, Plattform-Symbole rechts */
      var symbole = Array.isArray(d.symbole) ? d.symbole : plattformSymbole();
      var sD = 84, sAbst = 16, sRand = 26;
      var sBreite = symbole.length ? symbole.length * sD + (symbole.length - 1) * sAbst : 0;
      var kopfMitte = KY + KOPF / 2;
      symbole.forEach(function (s, i) {
        var sx = KX + KW - sRand - sBreite + i * (sD + sAbst);
        g.beginPath(); g.arc(sx + sD / 2, kopfMitte, sD / 2, 0, Math.PI * 2); g.fillStyle = '#111'; g.fill();
        symbol(g, s.pfade, sx + sD / 2 - 23, kopfMitte - 23, 46, A, s.raster);
      });
      var marke = String(d.kopf || d.marke || radioName() || 'DNTK RADIO & TV');
      var platz = KW - 44 - (sBreite ? sBreite + sRand + 30 : 44);
      var plus = d.plus ? 34 : 0, luft = d.plus ? 18 : 0;
      var groesse = 42, abstand = 8;
      g.font = '900 ' + groesse + 'px ' + SCHRIFT;
      while (groesse > 26 && plus + luft + gesperrtBreite(g, marke, abstand) > platz) {
        groesse -= 2; abstand = Math.max(4, Math.round(groesse / 5));
        g.font = '900 ' + groesse + 'px ' + SCHRIFT;
      }
      g.textBaseline = 'middle';
      var mx = KX + 44;
      if (d.plus) {
        /* DNTK-PLUS: Plus-Zeichen immer im DNTK-Rot, Schrift weiss */
        g.fillStyle = '#cd0039';
        g.fillRect(mx, kopfMitte - 5, plus, 10);
        g.fillRect(mx + plus / 2 - 5, kopfMitte - plus / 2, 10, plus);
        g.fillStyle = '#fff';
      } else {
        g.fillStyle = A;
      }
      gesperrt(g, marke, mx + plus + luft, kopfMitte + 2, abstand);

      /* Titel und Artist im Verlauf, darunter Herz, Teilen, Plus (nur Bild) */
      var mitte = KX + KW / 2;
      var aktionY = CU - 64;
      symbol(g, SYM.herz, mitte - 160 - 25, aktionY - 25, 50, '#3a3a3a');
      symbol(g, SYM.teilen, mitte - 26, aktionY - 26, 52, '#fff');
      rund(g, mitte + 128, aktionY - 26, 88, 52, 12);
      g.fillStyle = '#2a2a2a'; g.fill();
      g.fillStyle = '#fff'; g.fillRect(mitte + 172 - 11, aktionY - 2, 22, 4); g.fillRect(mitte + 172 - 2, aktionY - 11, 4, 22);

      var zweite = String(d.artist || d.info || '').trim();
      g.save();
      g.shadowColor = 'rgba(0, 0, 0, 0.75)';
      g.shadowBlur = 24;
      g.textAlign = 'center';
      g.textBaseline = 'alphabetic';
      var y = CU - 150;
      if (zweite) {
        g.fillStyle = 'rgba(255, 255, 255, 0.88)';
        g.font = '500 42px ' + SCHRIFT;
        g.fillText(zeilen(g, zweite, KW - 100, 1)[0] || '', mitte, y);
        y -= 74;
      } else {
        y -= 20;
      }
      g.fillStyle = '#fff';
      g.font = '800 70px ' + SCHRIFT;
      var tz = zeilen(g, d.titel || marke, KW - 100, 2);
      for (var t = tz.length - 1; t >= 0; t--) { g.fillText(tz[t], mitte, y); y -= 82; }
      g.restore();

      /* Fortschritt: Zeit, Leiste, Griff */
      var py = CU + LEISTE / 2 + 4;
      var z = d.zeit || null;
      var lx = KX + 64, rx = KX + KW - 64;
      g.font = '500 30px ' + SCHRIFT;
      g.fillStyle = '#9a9a9a';
      g.textBaseline = 'middle';
      if (z && z.jetzt && z.dauer) {
        g.textAlign = 'left'; g.fillText(z.jetzt, KX + 40, py);
        g.textAlign = 'right'; g.fillText(z.dauer, KX + KW - 40, py);
        lx = KX + 150; rx = KX + KW - 150;
      }
      rund(g, lx, py - 5, rx - lx, 10, 5);
      g.fillStyle = '#3a3a3a'; g.fill();
      var anteil = (z && z.anteil >= 0 && z.anteil <= 1) ? z.anteil : 0.04;
      var gx = lx + (rx - lx) * anteil;
      g.beginPath(); g.arc(gx, py, 25, 0, Math.PI * 2); g.fillStyle = '#fff'; g.fill();
      g.beginPath(); g.arc(gx, py, 19, 0, Math.PI * 2); g.fillStyle = A; g.fill();

      /* Bedienung (nur Bild): Zufall, Zurueck, Abspielen, Vor, Wiederholen */
      var by = CU + LEISTE + BED / 2 - 8;
      symbol(g, SYM.zufall, KX + 92 - 30, by - 30, 60, '#8a8a8a');
      symbol(g, SYM.zurueck, mitte - 210 - 34, by - 34, 68, '#e6e6e6');
      g.beginPath(); g.arc(mitte, by, 82, 0, Math.PI * 2); g.fillStyle = '#fff'; g.fill();
      symbol(g, SYM.spielen, mitte - 40, by - 44, 88, '#000');
      symbol(g, SYM.vor, mitte + 210 - 34, by - 34, 68, '#e6e6e6');
      symbol(g, SYM.wiederholen, KX + KW - 92 - 30, by - 36, 60, '#8a8a8a');
      g.fillStyle = A;
      g.font = '800 22px ' + SCHRIFT;
      g.textAlign = 'center';
      g.fillText('OFF', KX + KW - 92, by + 44);
      g.restore();

      /* Rand der Karte in der Akzentfarbe */
      g.lineWidth = 3;
      g.strokeStyle = A;
      rund(g, KX, KY, KW, KH, KR);
      g.stroke();

      return new Promise(function (ok) {
        try {
          c.toBlob(function (blob) {
            if (!blob) { ok(null); return; }
            var name = String(d.titel || 'dntk').toLowerCase()
              .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
              .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'dntk';
            try { ok(new File([blob], name + '-story.jpg', { type: 'image/jpeg' })); } catch (e) { ok(null); }
          }, 'image/jpeg', 0.9);
        } catch (e) { ok(null); }
      });
    }).then(null, function () { return null; });
  }

  /* ------------------------------------------------------------- Teilen */
  function kannDateien() { return !!(navigator.share && navigator.canShare); }
  function schluessel(d) {
    return d.schluessel || [d.marke, d.kopf, d.plus ? 1 : 0, d.titel, d.artist, d.info, d.ruf, farbe(d.akzent), coverListe(d.cover).slice(0, 4).join('|')].join('|');
  }
  /* Bild bauen (hoechstens WARTEN ms), fuer denselben Inhalt nur einmal. */
  function bild(d) {
    var s = schluessel(d);
    if (merk && merk.schluessel === s) { return merk.versprechen; }
    var v = new Promise(function (ok) {
      var fertig = false;
      var uhr = setTimeout(function () { if (!fertig) { fertig = true; ok(null); } }, WARTEN);
      storyBild(d).then(function (datei) {
        if (fertig) { return; }
        fertig = true;
        clearTimeout(uhr);
        ok(datei);
      });
    });
    merk = { schluessel: s, versprechen: v };
    v.then(function (datei) { if (!datei && merk && merk.versprechen === v) { merk = null; } });
    return v;
  }
  function vorbereiten(d) {
    try { if (d && kannDateien() && coverListe(d.cover).length) { bild(d); } } catch (e) {}
  }
  /* Story-Bild mit Text und Link teilen. true = geteilt oder vom Nutzer abgebrochen,
     false = nicht moeglich (der Aufrufer teilt dann wie bisher). Danach wird das Bild beim naechsten
     Teilen neu gebaut (aktuelle Stelle im Fortschritt). */
  function teile(d) {
    if (!d || !d.link || !kannDateien() || !coverListe(d.cover).length) { return Promise.resolve(false); }
    if (laeuft && Date.now() - laeuft < 3000) { return Promise.resolve(true); }
    laeuft = Date.now();
    return bild(d).then(function (datei) {
      var geht = false;
      try { geht = !!datei && navigator.canShare({ files: [datei] }); } catch (e) { geht = false; }
      if (!geht) { return false; }
      /* Kein url- und kein title-Feld: sonst haengen viele Apps den Link doppelt an. */
      return navigator.share({ files: [datei], text: (d.text ? d.text + '\n' : '') + d.link }).then(
        function () { return true; },
        function (err) { return !!(err && err.name === 'AbortError'); });
    }).then(function (r) { laeuft = 0; merk = null; return r; }, function () { laeuft = 0; merk = null; return false; });
  }

  /* ------------------------------------------------------------- Radio */
  /* Akzentfarbe des Radios (--accent an .dntk-pro-wrapper). */
  function akzent() {
    try {
      var w = document.querySelector('.dntk-pro-wrapper');
      return farbe(w ? window.getComputedStyle(w).getPropertyValue('--accent') : '');
    } catch (e) { return farbe(''); }
  }
  function text(id) {
    var el = document.getElementById(id);
    return el ? String(el.innerText || el.textContent || '').trim() : '';
  }
  function laufendeId() {
    try { return currentId; } catch (e) { return ''; }
  }
  /* Derselbe Link wie bisher: Seite + Parameter, dann die Kennung des Verkaeufers. */
  function link(name, wert) {
    var u = new URL(window.location.origin + window.location.pathname);
    u.searchParams.set(name, wert);
    window.mmKennungAnhaengen(u);
    return u.href;
  }

  /* Stelle im Player (Zeit, Laenge, Anteil), falls die Laenge bekannt ist. */
  function playerZeit() {
    var jetzt = text('current-time'), dauer = text('duration');
    if (!dauer || /^0+:00$/.test(dauer)) { return null; }
    var r = document.getElementById('seek-slider');
    var anteil = r ? Number(r.value) / Number(r.max || 100) : 0;
    if (!(anteil >= 0 && anteil <= 1)) { anteil = 0; }
    return { jetzt: jetzt || '0:00', dauer: dauer, anteil: anteil };
  }

  function trackDaten() {
    var id = laufendeId();
    if (!id) { return null; }
    var bild = document.getElementById('display-cover');
    var cover = window.currentCoverLarge || (bild && bild.src) || '';
    if (!cover || String(cover).indexOf('data:') === 0) { return null; }
    var plus = String(id).indexOf('plus-') === 0;
    var titel = text('display-title');
    var artist = text('display-artist');
    return {
      schluessel: 'track|' + id + '|' + cover,
      cover: cover,
      titel: titel || 'DNTK Radio',
      artist: artist,
      /* Slogan nur bei freien Titeln; nicht doppelt, wenn er schon als Artist steht (Senderkennung). */
      info: (plus || artist.toLowerCase().indexOf('lossless') >= 0) ? '' : 'LOSSLESS & FREE',
      ruf: 'Jetzt reinhören',
      marke: plus ? 'DNTK-PLUS' : 'DNTK RADIO',
      kopf: plus ? 'DNTK-PLUS' : (radioName() || 'DNTK RADIO & TV'),
      plus: plus,
      zeit: playerZeit(),
      akzent: akzent(),
      link: link('play', id),
      text: (titel || 'DNTK Radio') + (artist ? ' · ' + artist : '') + '\nJetzt reinhören bei ' + (plus ? 'DNTK-PLUS' : 'DNTK Radio')
    };
  }
  function tvDaten(tvId) {
    if (!tvId || typeof window.findTVCardById !== 'function') { return null; }
    var karte = window.findTVCardById(tvId);
    if (!karte || !karte.dataset) { return null; }
    var cover = karte.dataset.tvCoverLarge || karte.dataset.tvCover || '';
    if (!cover) { return null; }
    var titel = String(karte.dataset.tvTitle || 'TV-Stream').trim();
    return {
      schluessel: 'tv|' + tvId + '|' + cover,
      cover: cover,
      titel: titel,
      artist: '',
      info: '',
      ruf: 'Jetzt reinschauen',
      marke: 'DNTK TV',
      kopf: radioName() || 'DNTK RADIO & TV',
      plus: false,
      akzent: akzent(),
      link: link('livetv', tvId),
      text: titel + '\nJetzt reinschauen bei DNTK TV'
    };
  }

  /* „Liste teilen“: Die Radio-Funktion baut den Link wie immer; ihr Teilen-Fenster wird fuer
     diesen einen (synchronen) Aufruf abgefangen, damit das Modul den Link ablesen kann.
     Rueckgabe: Link | null (Radio hat selbst gemeldet, z. B. „Liste ist leer“) | undefined (Abfangen ging nicht). */
  function listenLink(selbst, args) {
    var eigen = Object.prototype.hasOwnProperty.call(navigator, 'share');
    var alt = navigator.share;
    var url = null, gefangen = false;
    try {
      navigator.share = function (x) { url = (x && x.url) || null; return Promise.resolve(); };
      gefangen = true;
      orig.liste.apply(selbst, args);
    } catch (e) {
      if (!gefangen) { url = undefined; }
    } finally {
      try { if (eigen) { navigator.share = alt; } else { delete navigator.share; } } catch (e) {}
    }
    return url;
  }
  function listenDaten(url) {
    var u = new URL(url);
    var sl = u.searchParams.get('sl');
    if (!sl) { return null; }
    var ids = decodeURIComponent(window.atob(sl)).split(',').filter(Boolean);
    var name = '';
    try { name = decodeURIComponent(u.searchParams.get('list_name') || ''); } catch (e) { name = u.searchParams.get('list_name') || ''; }
    name = String(name).trim() || 'DNTK Radio';
    var cover = [];
    if (typeof window.findTrackById === 'function') {
      for (var i = 0; i < ids.length && cover.length < 4; i++) {
        var el = window.findTrackById(ids[i]);
        var c = el && el.dataset ? (el.dataset.coverLarge || el.dataset.cover || '') : '';
        if (c && c.indexOf('data:') !== 0 && cover.indexOf(c) < 0) { cover.push(c); }
      }
    }
    if (!cover.length) { return null; }
    var anzahl = ids.length + ' Titel';
    return {
      schluessel: 'liste|' + name + '|' + ids.length + '|' + cover.join('|'),
      cover: cover,
      titel: name,
      artist: '',
      info: anzahl,
      ruf: 'Jetzt reinhören',
      marke: 'DNTK RADIO',
      kopf: radioName() || 'DNTK RADIO & TV',
      plus: false,
      akzent: akzent(),
      link: url,
      text: name + ' · ' + anzahl + '\nJetzt reinhören bei DNTK Radio'
    };
  }

  function haengeEin() {
    if (typeof window.mmKennungAnhaengen !== 'function') { return; }
    if (!orig.track && typeof window.shareCurrentTrack === 'function') {
      orig.track = window.shareCurrentTrack;
      window.shareCurrentTrack = function () {
        var selbst = this, args = arguments, d = null;
        try { d = trackDaten(); } catch (e) { d = null; }
        return teile(d).then(function (ok) { if (!ok) { return orig.track.apply(selbst, args); } });
      };
    }
    if (!orig.tv && typeof window.shareTVStream === 'function') {
      orig.tv = window.shareTVStream;
      window.shareTVStream = function (e, tvId) {
        var selbst = this, args = arguments, d = null;
        try { if (e && e.stopPropagation) { e.stopPropagation(); } } catch (x) {}
        try { d = tvDaten(tvId); } catch (x) { d = null; }
        return teile(d).then(function (ok) { if (!ok) { return orig.tv.apply(selbst, args); } });
      };
    }
    if (!orig.liste && typeof window.shareCurrentList === 'function') {
      orig.liste = window.shareCurrentList;
      window.shareCurrentList = function () {
        var selbst = this, args = arguments;
        if (!kannDateien()) { return orig.liste.apply(selbst, args); }
        var url = listenLink(selbst, args);
        if (url === undefined) { return orig.liste.apply(selbst, args); }
        if (!url) { return undefined; }
        var d = null;
        try { d = listenDaten(url); } catch (e) { d = null; }
        return teile(d).then(function (ok) { if (!ok) { return orig.liste.apply(selbst, args); } });
      };
    }
    /* Schon beim Antippen des Teilen-Knopfs vorbereiten, damit das Teilen-Fenster schnell kommt. */
    document.addEventListener('pointerdown', function (e) {
      if (!kannDateien()) { return; }
      var k = e.target && e.target.closest ? e.target.closest('[onclick*="shareCurrentTrack"], [onclick*="shareTVStream"]') : null;
      if (!k) { return; }
      try {
        var klick = k.getAttribute('onclick') || '';
        var tv = klick.match(/shareTVStream\(\s*event\s*,\s*'([^']+)'/);
        vorbereiten(tv ? tvDaten(tv[1]) : trackDaten());
      } catch (x) {}
    }, { passive: true, capture: true });
  }

  window.DNTKStory = { bild: storyBild, teile: teile, vorbereiten: vorbereiten, farbe: farbe, symbole: symboleAus };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', haengeEin);
  } else {
    haengeEin();
  }
})();
